@if(loading) {
<app-loading class="h-100 loading-container" [text]="'Loading'"></app-loading>
} @else {
<div class="d-flex flex-row  align-items-start flex-wrap gap-3">
  <div
    class="container d-flex flex-column align-items-center justify-content-center flex-wrap accello-card-primary"
    [ngClass]="{ active: card.isClicked, 'empty-container': card.isEmpty }"
    (click)="onActionFire(card)"
    (keydown.enter)="onActionFire(card)"
    *ngFor="let card of cardList; let i = index"
  >
  <div class="edit-icon-container" (click)="onEdit($event, card)" (keydown.enter)="onEdit($event, card)"><img class="edit-icon" *ngIf="card.isEditable" title="Edit"
    [src]="'images/table/table-item-edit.svg' | assetUrl"
    width="16"
    height="16"
    alt="edit"
  /></div>
  <div class="checkbox-container" *ngIf="card.isSelectable">
    <input
      type="checkbox"
      (click)="onCheckboxClick($event, card)"
      [checked]="isSelected(card)"
      (keydown.enter)="onCheckboxClick($event, card)"
    />
  </div>

    <div>
      <div
        class="context-menu"
        *ngIf="card.isContextMenu"
        (click)="toggleContextMenu($event, i)"
        (keydown.enter)="toggleContextMenu($event, i)"
      >
        <mat-icon class="more">more_vert</mat-icon>
      </div>
      <ul
        class="context-menu-items"
        *ngIf="contextMenuIndex === i && card.isContextMenu"
        [ngStyle]="{
          top: contextMenuPosition.y + 'px',
          left: contextMenuPosition.x + 'px'
        }"
      >
        <li
          *ngFor="let item of card.contextMenuItems"
          (click)="handleContextMenuAction($event, item, card)"
          (keydown.enter)="handleContextMenuAction($event, item, card)"
        >
          <span
            class="header-12"
            [ngClass]="{
              'text-danger': item === 'Delete',
              'text-default': item !== 'Delete'
            }"
          >
            {{ item }}
          </span>
        </li>
      </ul>
      <div
        class="inner-container d-flex flex-column align-items-center justify-content-center flex-wrap"
        *ngIf="card.isEmpty"
      >
        <div class="card-title text-center position-relative rounded-2">
          <mat-icon>{{ card.icon }}</mat-icon>
        </div>
      </div>

      <div *ngIf="!card.isEmpty">
        <div
          class="card-title text-center position-relative rounded-2 d-flex flex-row justify-content-center align-items-center"
        >
          <img
          [src]="'images/virtusa-icons/card-icon.svg' | assetUrl" alt="card icon"
          width="40"
          height="40"
        />
          <span class="header-11 title">{{ card.title || card.name }}</span>
          <span class="header-12 description">{{ card.description }}</span>
        </div>
      </div>
    </div>
    <!-- 
      <div *ngIf="loading && card.isClicked && !card.isEmpty">
        <span
        class="spinner-border spinner-border-sm mx-2"
        role="status"
        aria-hidden="true"
      ></span>
      
      </div> -->
  </div>
</div>
}
